import { render, staticRenderFns } from "./QuestionSelect.vue?vue&type=template&id=5f1c0d94&scoped=true&"
import script from "./QuestionSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelect.vue?vue&type=style&index=0&id=5f1c0d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c0d94",
  null
  
)

export default component.exports